'use strict';

/**
 * Author:fanglijuan
 * 一键快签 操作日志
 * Time:2019-04-28
 */
angular.module('quickSignOperationLogModule', []).controller('quickSignOperationLogCtrl', ['$scope', '$sce', '$q', '$modal', '$timeout', '$state', '$location', '$window', '$filter', 'trsHttpService', '$stateParams', 'editcenterRightsService', 'modalDialog', 'editingCenterService', 'localStorageService', 'initSingleSelecet', 'appQuickSignService',
    function($scope, $sce, $q, $modal, $timeout, $state, $location, $window, $filter, trsHttpService, $stateParams, editcenterRightsService, modalDialog, editingCenterService, localStorageService, initSingleSelecet, appQuickSignService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.status = {
                keywords: '',
                copyCurrPage: 1,
                personJsons: [{ name: '全部人员', value: '' }],
                person: { name: '全部人员', value: '' }
            };
            $scope.params = {
                'serviceid': 'mlf_appquickpublish',
                'methodname': 'queryRecord',
                'SITEID': $stateParams.siteid,
                'cruser': '', // 签发人
                'keyword': '', // 关键字
                'CURRPAGE': $scope.page.CURRPAGE,
                'PAGESIZE': $scope.page.PAGESIZE,
                'OperTime': '1m', // 默认一个月
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]null
         */
        function initData() {
            initDropDown();
            requestData();
        }
        // 初始化下拉框
        function initDropDown() {
            // 初始化选择日期
            $scope.selectdTime = initSingleSelecet.newspaperDraftTime();
            $scope.selectdTimeDefault = angular.copy($scope.selectdTime[3]);
            // 人员
            getUserLists();
        }

        /**
         * [getUserLists description] 获取用户列表
         * @return {[type]} [description]
         */
        function getUserLists() {
            var params = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'queryPubUsers',
                SITEID: $stateParams.siteid
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < data.length; i++) {
                    $scope.status.personJsons.push({ name: data[i].TRUENAME, value: data[i].USERNAME });
                }
            });
        }

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.keyword = $scope.status.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            // $scope.params.OperTime = $scope.selectdTimeDefault.value;
            // $scope.params.cruser = $scope.status.region.value;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转到指定页面
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.params[key] = value;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE = $scope.page.copyCurrPage = 1;
            if (key == 'OperTime') {
                if (value.length < 10) {
                    $scope.params.OprTimeStart = null;
                    $scope.params.OprTimeEnd = null;
                } else {
                    $scope.params.OprTimeStart = $scope.data.fromdate;
                    $scope.params.OprTimeEnd = $scope.data.untildate;
                    $scope.params[key] = null;
                }
            }
            requestData();
        };
    }
]);
